import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {useValue} from "@morningtrain/react-resources";

function Heading(props) {
    const {name, defaultValue} = props;

    let value = useValue(name, defaultValue);
    let Tag = `h${props.level}`;

    return (
        <Tag className={props.className}>
            {value}
        </Tag>
    );
}

Heading.defaultProps = {
    defaultValue: null,
    level: 1,
    className: '',
}

Heading.propTypes = {
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.any,
    level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
    className: PropTypes.string
}

export default observer(Heading);

